import { DexStatistics, IStatistics, LongShortStatistics } from "@root/common";
import dayjs from "dayjs";

type TSeconds = number;
type TMinutes = number;

export function isNewTimeFrame(curTimeFrame: TSeconds, timeFrame: number) {
    // let time: TSeconds = Date.now() / 1000 - timeFrame*60
    // time -= new Date().getTimezoneOffset()*60
    const time = +dayjs() / 1000 - new Date().getTimezoneOffset()*60 - timeFrame*60

    return time > curTimeFrame
}

export function wasDisconnected(curTimeFrame: TSeconds, timeFrame: number) {
//   let time: TSeconds = Date.now() / 1000 - 2*timeFrame*60
//   time -= new Date().getTimezoneOffset()*60
  const time = +dayjs() / 1000 - new Date().getTimezoneOffset()*60 - 2*timeFrame*60

  return time > curTimeFrame
}

export function getLongShortTitles (statiscitcs?: DexStatistics): Record<string, string | undefined> {
  if (!statiscitcs) { return {}}

  const ask = getFLoat(statiscitcs.orderbook?.asks?.[0].price)
  const bid = getFLoat(statiscitcs.orderbook?.bids?.[0].price)
    return {
        "Фандинг": getValue(statiscitcs.funding) || '-',
        "Период": getValue(statiscitcs.period, 'ч') || '-' ,
        "Стакан": ((ask - bid) / (ask + bid) * 2 * 100).toFixed(2) + '%',
        "Лимит": statiscitcs.limit ? statiscitcs.limit + '$'  : ' -',
        "24Ч объем": statiscitcs.volumeFut
    }
}

function getValue (val: string, postfix="%") {
    const parsed = parseFloat(val)

    if (Number.isNaN(parsed)) {
        return null
    }

    return `${parsed}${postfix}`
}

export function getEnterSpread(_message?: IStatistics) {
  const message = _message as DexStatistics
  if (!message) { return "-"}

  if (message.longShort === "long") {
    const ask = getFLoat(message.orderbook.asks?.[0].price)
    const dex = parseFloat(message.dexRate)

    const spread = getSpread(ask, dex)

    return spread
  }

  if (message.longShort === "short") {
    const bid = getFLoat(message.orderbook.bids?.[0].price)
    const dex = parseFloat(message.dexRate)

    const spread = getSpread(dex, bid)

    return spread
  }

  return "-"
}

export function getCloseSpread(_message?: IStatistics) {
  const message = _message as DexStatistics
  if (!message) { return "-"}

  if (message.longShort === "short") {
    const ask = getFLoat(message.orderbook.asks?.[0].price)
    const dex = parseFloat(message.dexRate)

    const spread = getSpread(ask, dex)

    return spread
  }

  if (message.longShort === "long") {
    const bid = getFLoat(message.orderbook.bids?.[0].price)
    const dex = parseFloat(message.dexRate)

    const spread = getSpread(dex, bid)

    return spread
  }

  return "-"
}

function getSpread(first: number, second: number) {
  return ((second - first) / (first + second) * 2 * 100).toFixed(2)
}

function getFLoat(value?: number | string) {
  if (!value) { return 0 }

  if (typeof value === "string") {
    return parseFloat(value)
  }

  return value
}
